export const TASK_STATUSES = ['Open', 'Active', 'Closed', 'Hold'] as const;
export const TASK_PRIORITIES = ['High', 'Medium', 'Low'] as const;
export const TASK_CATEGORIES = ['Task', 'Project', 'Purchase', 'Campaign'] as const;

export const STATUS_COLORS = {
  Open: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  Active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  Closed: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
  Hold: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
} as const;

export const PRIORITY_COLORS = {
  High: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  Medium: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  Low: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
} as const;

export const CATEGORY_COLORS = {
  Task: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  Project: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  Purchase: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  Campaign: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200',
} as const;